import ListSubheader from '@mui/material/ListSubheader';

const listSubheader = ({children}) => {
  return (
    <ListSubheader sx={{ color: 'onSurface.light', textTransform: 'uppercase' }}> {children} </ListSubheader>
  );
}

export default listSubheader;